import React from 'react';
import { Container, Grid, TAGTypography, useMediaQuery, useTheme } from '../../..';

var MeetOurDentistsSection = function MeetOurDentistsSection(_ref) {
  var children = _ref.children,
      description = _ref.description,
      sectionBackground = _ref.sectionBackground,
      _ref$sectionInfoAlign = _ref.sectionInfoAlignment,
      sectionInfoAlignment = _ref$sectionInfoAlign === void 0 ? 'center' : _ref$sectionInfoAlign,
      title = _ref.title;
  var theme = useTheme();
  var isSmall = useMediaQuery(theme.breakpoints.down('md'));
  return React.createElement(Grid, null, React.createElement(Container, null, React.createElement(Grid, {
    item: true,
    sx: {
      backgroundColor: sectionBackground,
      p: {
        xs: '44px 32px',
        md: '48px 81px'
      }
    }
  }, React.createElement(Grid, {
    container: true,
    direction: "column",
    justifyContent: "center",
    alignItems: sectionInfoAlignment,
    spacing: 2,
    sx: {
      marginBottom: {
        xs: '40px',
        md: '48px'
      }
    }
  }, React.createElement(Grid, {
    item: true
  }, React.createElement(TAGTypography, {
    variant: "h1",
    color: 'text.primary',
    sx: {
      display: 'flex',
      textAlign: 'center'
    }
  }, title)), description && React.createElement(Grid, {
    item: true
  }, React.createElement(TAGTypography, {
    variant: isSmall ? 'bodyMediumBook' : 'bodyLargeBook',
    color: "text.tertiary",
    sx: {
      display: 'flex',
      textAlign: 'center'
    }
  }, description))), children)));
};

export default MeetOurDentistsSection;